import { JournalStatisticsContextProvider } from '../../contexts/journalStatistics.tsx';
import JournalStatisticsBody from './body.tsx';
import JournalStatisticsHeader from './header.tsx';

const Journal = () => {
    return (
        <JournalStatisticsContextProvider>
            <JournalStatisticsHeader />
            <JournalStatisticsBody />
        </JournalStatisticsContextProvider>
    );
};

export default Journal;
